import React from "react";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LabourerForm from "./labourerForm";

const useStyles = makeStyles({
    root: {
        width: 347,
        height: "auto",
        "& .MuiBackdrop-root": {
            background: "transparent",
            boxShadow: "none",
        },
    },
});

export const LabourerDrawerForm = (props) => {
    const classes = useStyles();
    const toggleDrawer = (close) => (event) => {
        props.closeform(close);
    };
    return (
        <Drawer
            variant="temporary"
            anchor="right"
            open={props.state.open}
            onClose={toggleDrawer(false)}
            classes={{ paper: props?.classes, root: classes.root }}
            PaperProps={{ style: props.dynamicHeight }}
            ModalProps={{ disableBackdropClick: true }}>
            {
                <div className={classes.root}>
                    <LabourerForm technician={props.state?.data} {...props} onclose={(close) => toggleDrawer(close)} />
                </div>
            }
        </Drawer>
    );
};
export default LabourerDrawerForm;
